/**
 * URLに特定のクエリパラメータが存在するか判定
 * @param {Location} location
 * @param {string} key
 * @returns {boolean}
 */
export const hasQueryParam = (location, key) => {
    const urlObj = new URL(location.href);
    return urlObj.searchParams.has(key);
}

/**
 * クエリパラメータを取得
 * @param {Location} location
 * @param {string} key
 * @return {string}
 */
export const getQueryParam = (location, key) => {
    const searchParams = new URLSearchParams(location.search);
    return searchParams.get(key);
}

/**
 * リファラーのホストとアプリケーションのホストが一致するか判定
 * @returns {boolean}
 */
export const isRefererHostMatchingAppHost = () => {
    const referer = document.referrer || '';
    if (!referer) {
        return false;
    }
    const refererHost = new URL(referer).host;
    const appHost = window.location.host;
    return refererHost === appHost;
};
